import { render, staticRenderFns } from "./FormulateObjectExtraInfo.vue?vue&type=template&id=d91e8388&"
import script from "./FormulateObjectExtraInfo.vue?vue&type=script&lang=ts&"
export * from "./FormulateObjectExtraInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports